import React from 'react';
import { Flex } from '@rebass/emotion';
import Card from '~components/PageBlocks/Card';

const ArticleCard = ({ data }) => {
  return <Card data={data} type={4} />;
};

export default ArticleCard;
